import utilities from './utilities'

const xhr_headers = {
  'X-Requested-With': 'XMLHttpRequest'
}

const search = {
  searchParams: {},
  htmlInMap(maps, useBoundingBox=false){
    return !maps.lgViewport && useBoundingBox
  },
  getHTML(maps, useBoundingBox=false) {
    fetch(search.searchPath(maps, useBoundingBox), { headers: xhr_headers})
    .then(response => response.text()).then(html => {
      search.render(html, maps, useBoundingBox)
    })
  },
  searchPath(maps, useBoundingBox) {
    maps.searchPath(useBoundingBox)
    search.searchParams = maps.searchParams
    search.searchParams.delete('map')
    if (!search.htmlInMap(maps, useBoundingBox)){
      search.searchParams.delete('map_results')  
    }
    return maps.searchPathName + '?' + search.searchParams
  },
  addClickListener(maps){
    let container = document.getElementById('search-results-container')
    if (container) {
      let pagination = container.querySelector('ul.pagination');
      if (pagination) {
        pagination.querySelectorAll('a.page-link').forEach(page => {
          page.addEventListener('click', event => {
            event.preventDefault();
            fetch(page.getAttribute('href'), { headers: xhr_headers })
            .then(response => response.text()).then(html => {
              search.render(html, maps)
            })
          })
        })
      }
      document.dispatchEvent(new CustomEvent('favorites.reload', {'detail': {'container': container}}))
      document.dispatchEvent(new CustomEvent('share.reload', {'detail': {'container': document}}))
    }
  },
  render(html, maps, useBoundingBox=false){
    let container_id = search.htmlInMap(maps, useBoundingBox) ? 'search-results-map-container' : 'search-results-container'
    let container = document.getElementById(container_id)

    if (container) {
      container.innerHTML = html

      if (!search.htmlInMap(maps, useBoundingBox)) {
        if (!utilities.elemIsVisible(document.getElementById('search-results-count'))) {
          let top = document.querySelector('.search-results-column .search-result-item').offsetTop;
          document.querySelector('.search-results-column').scrollTo({top: top}) //, behavior: 'smooth'
        }        
        search.addClickListener(maps)
      } else {
        document.querySelector('#search-results-map-container').scrollTo({left: 0})
        document.dispatchEvent(new CustomEvent('favorites.reload', {'detail': {'container': container}}))
        document.dispatchEvent(new CustomEvent('share.reload', {'detail': {'container': document}}))
      }
      maps.bindMarkersPopUp()
    }
  }
}

export default search
